module.exports = __webpack_public_path__ + "e2cf662ccb13e6bdd5628560c201d098.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loader.gif
// module id = 770
// module chunks = 0